import { ApolloClient } from '@apollo/client'

import ApolloCache from './apollo-cache'
import ApolloRootLink from './apollo-root-link'

class Apollo {
  constructor({ httpUri, subscriptionUri }) {
    this.cache = new ApolloCache()
    this.link = new ApolloRootLink({ httpUri, subscriptionUri })

    this.client = new ApolloClient({
      link: this.link.link,
      cache: this.cache.cache,
    })
  }

  async addPossibleTypesToCache() {
    await this.cache.setPossibleTypes({ uri: this.link.httpUri })

    this.client = new ApolloClient({
      link: this.link.link,
      cache: this.cache.cache,
    })
  }

  addAccessTokenToHeaders(getAccessToken, getNewAccessToken) {
    this.link.addAccessTokenToHeaders(getAccessToken, getNewAccessToken)

    this.client = new ApolloClient({
      link: this.link.link,
      cache: this.cache.cache,
    })
  }

  removeAccessTokenFromHeaders() {
    this.link.removeAccessTokenFromHeaders()

    this.client = new ApolloClient({
      link: this.link.link,
      cache: this.cache.cache,
    })
  }
}

export default Apollo
